import { useTranslation } from 'next-i18next'

import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import {
  selectShowAllGames,
  selectShowAllLearningTools,
  setShowAllGames,
  setShowAllLearningTools,
} from '~/redux/slices/menu'

import { MenuCategoryType } from '../types/category.types'
import { MenuCategoryKeys } from '../constants/category.const'

import MenuItem from './MenuItem'
import SwitchProfile from './switchProfile'

const UNDERLINE_COLORS: { [key: string]: string } = {
  [MenuCategoryKeys.LEARNING_TOOLS]: 'bg-blue-periwinkle',
  [MenuCategoryKeys.GAMES]: 'bg-orange-mellow',
  [MenuCategoryKeys.PROFILE]: 'bg-green-celadon',
}

export default function MenuSection({ category }: { category: MenuCategoryType }): React.ReactElement {
  const { t } = useTranslation('menu')
  const dispatch = useAppDispatch()
  const showAllLearningTools = useAppSelector(selectShowAllLearningTools)
  const showAllGames = useAppSelector(selectShowAllGames)

  const isShowMoreVisible =
    (category.key === MenuCategoryKeys.LEARNING_TOOLS && !showAllLearningTools) ||
    (category.key === MenuCategoryKeys.GAMES && !showAllGames)

  const handleShowMore = (): void => {
    if (category.key === MenuCategoryKeys.LEARNING_TOOLS) {
      dispatch(setShowAllLearningTools(true))
    } else if (category.key === MenuCategoryKeys.GAMES) {
      dispatch(setShowAllGames(true))
    }
  }

  return (
    <div className="flex w-full flex-col gap-0.5" data-test-id={`menu-section-${category.key}`}>
      <div className="flex flex-col items-start gap-1.5 pb-2.5">
        <p className="text-xs font-bold uppercase leading-5.5 text-white">{category.title}</p>
        <span className={`h-0.5 w-8 rounded-full ${UNDERLINE_COLORS[category.key] ?? 'bg-blue-periwinkle'}`} />
      </div>
      {category.key === MenuCategoryKeys.PROFILE && <SwitchProfile />}
      {category.subCategories?.map((sub) => (
        <MenuItem item={sub} key={sub.key} />
      ))}
      {isShowMoreVisible && (
        <button
          className="rounded-2 px-2.5 py-2 text-left text-xs font-medium leading-3 text-white"
          data-test-id={`menu-show-more-${category.key}`}
          onClick={handleShowMore}
        >
          {t('showMore')}
        </button>
      )}
    </div>
  )
}
